import { PerformanceResourceTimingWithServerTiming } from '@ms/yammer-telemetry/dist/performance';

import { isReportableResourceEntry } from './isReportableResourceEntry';
import { getResourcePerformanceEvent } from './resourcePerformanceEvent';
import { GetEventsForPerformanceEntries } from './types';

const getEventsForResourceEntries: GetEventsForPerformanceEntries = (entries) =>
  entries
    .filter((entry) => isReportableResourceEntry(entry as PerformanceResourceTiming))
    .map((en) => getResourcePerformanceEvent(en as PerformanceResourceTimingWithServerTiming));

export default getEventsForResourceEntries;
